import CryptoJS from 'crypto-js';
import { toast } from 'react-toastify';
import { CONFIG } from '../config';

export const translate = (message) => {
    console.log('message', message);
    const translations = {
        'contract report': 'Relatório de Contrato',
        'with contract code': 'com o código de contrato',
        'for reference date': 'para a data de referência',
        'already exists': 'já existe',
        'no file provided.': 'Nenhum ficheiro fornecido.',
        'contract report cannot be deleted.': 'O contrato não pode ser apagado pois já foi submetido',
        'Contrato  report cannot be deleted.': 'O contrato não pode ser apagado pois já foi submetido',
        'Contract report cannot be deleted.': 'O contrato não pode ser apagado pois já foi submetido',
        'phonogram report cannot be deleted.': 'O fonograma não pôde ser apagado',
        'user not found.': 'Utilizador não encontrado.',
        'contracts': 'contratos',
        'phonograms': 'fonogramas',
        'imported': 'Importado',
        'archived': 'Arquivado',
        'locality': 'Localidade',
        'municipality': 'Município',
        'district': 'Distrito',
        'type': 'Tipo',
        'contract_type': 'Tipo de contrato',
        'box_type': 'Atividade',
        'sector': 'Setor',
        'box with box code': 'Box com o código',
        'is missing.': 'não foi encontrada.',
        'true': 'Sim',
        'false': 'Não',
        'artist': 'Artista',
        'reference_date': 'Data de Referência',
        'label': 'Editora',
        'has_rights': 'Tem Direitos',
        'partner': 'Entidade Exploradora',
        'contract name': 'Nome do Contrato',
        'contract number': 'Número do Contrato',
        'this field may not be blank.': 'Este campo não pode estar vazio.',
        'invalid credentials': 'Credenciais inválidas',
        'enter a valid email address.': 'Insira um endereço de email válido.',
        'you do not have permission to perform this action.': 'Não tem permissão para executar esta ação.',
        'contract with contract code': 'Contrato com o código',
        'is missing': 'não encontrado',
    };

    const translateString = (str) => {
        const lowerCaseMessage = typeof str === 'string' ? str.toLowerCase() : '';
        console.log('lowerCaseMessage', lowerCaseMessage);
        return translations[lowerCaseMessage] || str;
    };

    const translateArray = (arr) => {
        return arr.map((item) => translate(item)).join(', ');
    };

    const translateComplexMessage = (str) => {

        const componentTranslations = {
            'Contract': 'Contrato',
            'Contract Report': 'Relatório de Contrato',
            'ContractReport': 'Relatório de Contrato',
            'Box': 'Box',
            'with contract code': 'com o código de contrato',
            'with box code': 'com o código',
            'for reference date': 'para a data de referência',
            'already exists': 'já existe',
            'is missing.': 'está em falta.',
            'is missing': 'não encontrado',
            'Cannot delete some instances of model': 'Não é possível apagar registros do modelo',
            'because they are referenced through restricted foreign keys': 'porque estão referenciados através de chaves estrangeiras restritas',
        };

        // Handle special cases with specific translations

        // Case: ContractReport already exists
        if (str && str.match(/ContractReport already exists/i)) {
            return "Contrato duplicado";
        }

        // Case: Contract (CODE) already exists in same associado
        if (str && str.match(/Contract \([^)]+\) already exists/i)) {
            const codeMatch = str.match(/\(([^)]+)\)/);
            return codeMatch
                ? `Já existe um contrato com o código ${codeMatch[1]} neste associado.`
                : 'Já existe um contrato com este código neste associado.';
        }

        // Case: Contract code used by another associado
        if (str && str.match(/Contract code \([^)]+\) is already used by another associado/i)) {
            const codeMatch = str.match(/\(([^)]+)\)/);
            return codeMatch
                ? `O código de contrato ${codeMatch[1]} já está a ser usado por outro associado.`
                : 'Este código de contrato já está a ser usado por outro associado.';
        }

        // Case: Generic contract already exists (import)
        if (str && str.match(/^Contract already exists\.?$/i)) {
            return 'Já existe um contrato com este código.';
        }

        // Handle "Contract with contract code (XXX) is missing" pattern
        if (str && str.match(/Contract with contract code \(\d+\) is missing/i)) {
            const codeMatch = str.match(/\((\d+)\)/);
            if (codeMatch && codeMatch[1]) {
                const contractCode = codeMatch[1];
                return `Contrato com o código ${contractCode} não encontrado`;
            }
        }

        // Handle "Box with box code (XXX) is missing" pattern
        if (str && str.match(/Box with box code \(\d+\) is missing/i)) {
            const codeMatch = str.match(/\((\d+)\)/);
            if (codeMatch && codeMatch[1]) {
                const boxCode = codeMatch[1];
                return `Box com o código ${boxCode} não foi encontrada`;
            }
        }

        // Handle Django foreign key constraint error specifically
        if (str && str.includes('restricted foreign keys')) {
            // Extract model name and the dependent model
            const modelMatch = str.match(/model '([^']+)'/);
            const referenceMatch = str.match(/foreign keys: '([^']+)'/);

            if (modelMatch && referenceMatch) {
                const modelName = modelMatch[1];
                const referencePath = referenceMatch[1];
                const referenceModel = referencePath.split('.')[0];

                // Translate the model names
                const translatedModel = componentTranslations[modelName] || modelName;
                const translatedReference = componentTranslations[referenceModel] || referenceModel;

                return `Não é possível apagar este ${translatedModel} porque está a ser usado em ${translatedReference}`;
            }
        }

        const patternsToIgnore = [
            /\{<.*?>\}/g,  // Ignore Django model instance representation
            /\b\d{1,2}\/\d{4}\b/g
        ];

        let filteredMessage = str;
        patternsToIgnore.forEach((pattern) => {
            filteredMessage = filteredMessage.replace(pattern, '').trim();
        });

        const translatedMessage = Object.entries(componentTranslations).reduce(
            (translated, [original, translatedText]) =>
                translated.replace(new RegExp(original, 'gi'), translatedText),
            filteredMessage
        );

        return translatedMessage.trim();
    };

    const translateObject = (obj) => {
        const entries = Object.entries(obj)
            .filter(([key]) => key !== 'error') // Exclude the 'error' key
            .map(([key, value]) => {
                const translatedValue = Array.isArray(value)
                    ? translateArray(value)
                    : translate(value);
                console.log(key, translatedValue);
                return `${translatedValue}`;
            });

        if (obj.error) {
            // First try direct translation of the error string
            const directTranslation = translateString(obj.error);

            // If direct translation didn't change anything, try complex message translation
            const errorValue = directTranslation !== obj.error
                ? directTranslation
                : translateComplexMessage(obj.error);

            entries.push(errorValue);
        }

        return entries.join('; ');
    };

    if (typeof message === 'string') {
        return translateString(message);
    } else if (Array.isArray(message)) {
        return translateArray(message);
    } else if (typeof message === 'object' && message !== null) {
        return translateObject(message);
    }
    console.log('message translated', String(message));
    return String(message);
};

/**
 * Returns a user-friendly error message in PT-PT for submit/network errors.
 * Handles ERR_NETWORK, ECONNABORTED, and missing response (connection dropped).
 */
export const getSubmitErrorMessage = (error) => {
    if (error?.code === 'ERR_NETWORK' || (!error?.response && error?.message?.toLowerCase().includes('network'))) {
        return 'Erro de ligação ao servidor. O servidor pode estar ocupado. Por favor, tente novamente em alguns minutos.';
    }
    if (error?.code === 'ECONNABORTED') {
        return 'O pedido demorou demasiado tempo. O servidor pode estar ocupado. Por favor, tente novamente em alguns minutos.';
    }
    if (!error?.response) {
        return 'Erro de ligação ao servidor. Por favor, verifique a sua ligação e tente novamente.';
    }
    const serverError = error.response?.data?.error || error.message;
    return serverError ? translate(serverError) : 'Ocorreu um erro inesperado. Por favor, tente novamente.';
};

export const CONTRACT_TYPE_OPTIONS = [
    { label: 'Standard', value: 'Standard' },
    { label: 'Tripartido', value: 'Tripartido' },
];

export const SECTORS_OPTIONS = {
    "comércio e serviços": [
        { label: 'Retalho', value: 'RETALHO' },
        { label: 'Desporto', value: 'DESPORTO' },
        { label: 'Saúde e Estética', value: 'SAÚDE E ESTÉTICA' },
        { label: 'Cabeleireiros', value: 'CABELEIREIROS' },
        { label: 'Transportes', value: 'TRANSPORTES' },
        { label: 'Educação', value: 'EDUCAÇÃO' },
        { label: 'Cultura', value: 'CULTURA' },
        { label: 'Outros', value: 'OUTROS' }
    ],
    "horeca": [
        { label: 'Hotéis e Empreendimentos Turísticos', value: 'HOTÉIS E EMPREENDIMENTOS TURÍSTICOS' },
        { label: 'Discotecas', value: 'DISCOTECAS' },
        { label: 'Bares', value: 'BARES' },
        { label: 'Restaurantes', value: 'RESTAURANTES' },
        { label: 'Cafetarias', value: 'CAFETARIAS' }
    ],
    "eventos": [
        { label: 'Eventos', value: 'EVENTOS' }
    ]
};

export const CONTRACT_NOT_FOUND_MESSAGE = 'Contrato não encontrado';

export const getContractCodeFieldKey = (identifier) => (
    identifier === 'contract_reports' ? 'partner_code' : 'partner_contract_code'
);

export const isContractMissingError = (error) => {
    const message = error?.response?.data?.error || error?.response?.data?.detail || '';
    return /contract with contract code.*is missing/i.test(String(message));
};

export const handleErrorMessage = (errorResponse, manualFields) => {
    const errorData = errorResponse.data;

    // Check if errorResponse contains individual field errors
    if (errorData && typeof errorData === 'object' && !errorData.error) {
        const translatedErrors = Object.keys(errorData).map((field) => {
            const translatedField = manualFields[field]?.placeholder || field; // Use the placeholder if it exists, otherwise fall back to the field name
            const rawFieldError = errorData[field];
            const fieldErrorText = Array.isArray(rawFieldError)
                ? rawFieldError.join(', ')
                : (rawFieldError != null ? String(rawFieldError) : '');
            const errorMessages = translate(fieldErrorText);
            return `${translatedField}: ${errorMessages}`;
        });

        const combinedErrorMessage = translatedErrors.join(' | ');
        toast.error('Erro ao adicionar: ' + combinedErrorMessage);
    } else {
        const errorMessage = errorData?.error
            ? translate(errorData.error)
            : (typeof errorData === 'string' ? translate(errorData) : null);
        toast.error(`Erro: ${errorMessage || 'Ocorreu um erro inesperado.'}`);
    }
};

export const formatLabel = (label) => {
    // Check if the label is a string
    if (typeof label !== 'string') {
        return label; // Return the label as-is if it's not a string (e.g., a number or boolean)
    }

    return label
        .toLowerCase() // Convert entire label to lowercase
        .split(' ') // Split by spaces to handle each word individually
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
        .join(' ') // Rejoin words with spaces
        .replace(/\bE\b/g, "e"); // Replace isolated "E" with "&"
};

const REFERENCE_MONTH_ABBR = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];

export const formatReferenceDate = (dateValue) => {
    if (!dateValue) return '-';

    const normalized = typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)
        ? `${dateValue}T00:00:00`
        : dateValue;
    const date = new Date(normalized);

    if (Number.isNaN(date.getTime())) return '-';

    return `${REFERENCE_MONTH_ABBR[date.getMonth()]} ${date.getFullYear()}`;
};

export const formatReferenceMonthLong = (dateValue) => {
    if (!dateValue) return '';

    const normalized = typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)
        ? `${dateValue}T00:00:00`
        : dateValue;
    const date = new Date(normalized);

    if (Number.isNaN(date.getTime())) return '';

    const label = date.toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' });
    return label.charAt(0).toUpperCase() + label.slice(1);
};

export const MAIN = {
    TABLE_PAGE_SIZE: 10,
}

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

export const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

export const decryptData = (data) => {
    const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const PATHS = {
    HOME: '/',
    LOGIN: '/login',
    CONTRACT_LIST: '/lista-contratos',
    // PASSMUSICA_VALIDATION: '/validacao-passmusica',
    CLIENTS_REPORTS: '/relatorio-clientes',
    FONOGRAMAS_REPORTS: '/relatorio-fonogramas',
    USERS: '/utilizadores',
    BOXES: '/boxes',
    RESET_PASSWORD: '/recuperar-password',
    CONFIRM_PARTNER: '/aceitar-convite',
};

export const USER_TYPES = {
    SUPER_USER: 'super_user',
    ADMIN: 'admin',
    VIEWER: 'viewer',
    GUEST: 'guest',
};

export const PARTNER_TYPE = {
    EXTERNAL: 'external',
    INTERNAL: 'internal',
};

export const PAGES = {
    [USER_TYPES.SUPER_USER]: [
        // Este user é a "Audiogest", para poder ver TODOS os dados e poder extraí-los, sem poder editar. Também não deve poder gerir contas
        { label: 'Dashboard', path: PATHS.HOME },
        { label: 'Gestão de Utilizadores', path: PATHS.USERS, options: { edit: true } }, // Pode criar users viewer e admin da própria conta
        { label: 'Lista de Contratos', path: PATHS.CONTRACT_LIST, options: { edit: false } },
        { label: 'Lista de Boxes', path: PATHS.BOXES, options: { edit: false } },
        { label: 'Relatório de Contratos', path: PATHS.CLIENTS_REPORTS, options: { edit: false, internal: false } },
        { label: 'Relatório de Fonogramas', path: PATHS.FONOGRAMAS_REPORTS, options: { edit: false, internal: false } },
        // { label: 'Validação Audiogest', path: PATHS.PASSMUSICA_VALIDATION },
    ],
    [USER_TYPES.ADMIN]: [
        // ADMIN + EXTERNAL (Este user é um parceiro AMFM responsável - Carlos da "Waybox", ou Henrique "Cognitive", etc. 
        //Portanto deverá apenas ter acesso aos próprios dados, com a excepção de poder ver o dashboard total e poder usar a validação PassMúsica). 
        //Também deverá poder criar users "VIEWER" associados à sua conta
        { label: 'Dashboard', path: PATHS.HOME },
        { label: 'Gestão de Utilizadores', path: PATHS.USERS, options: { edit: true } }, // Apenas pode criar users viewer
        { label: 'Lista de Contratos', path: PATHS.CONTRACT_LIST, options: { edit: true, internal: true } },
        { label: 'Lista de Boxes', path: PATHS.BOXES, options: { edit: true, internal: true } },
        { label: 'Relatório de Contratos', path: PATHS.CLIENTS_REPORTS, options: { edit: true, internal: false } },
        { label: 'Relatório de Fonogramas', path: PATHS.FONOGRAMAS_REPORTS, options: { edit: true, internal: false } },
        // { label: 'Validação Audiogest', path: PATHS.PASSMUSICA_VALIDATION },
    ],
    [USER_TYPES.VIEWER]: [
        // Este user é um empregado de parceiro AMFM "Waybox", "Cognitive", etc. Deverá apenas ter acesso aos dados do próprio parceiro, 
        //com a exceção do dashboard TOTAL. Não deverá poder criar nem gerir utilizadores
        { label: 'Dashboard', path: PATHS.HOME },
        { label: 'Lista de Contratos', path: PATHS.CONTRACT_LIST, options: { edit: false, internal: true } },
        { label: 'Lista de Boxes', path: PATHS.BOXES, options: { edit: false, internal: true } },
        { label: 'Relatório de Contratos', path: PATHS.CLIENTS_REPORTS, options: { edit: false, internal: false } },
        { label: 'Relatório de Fonogramas', path: PATHS.FONOGRAMAS_REPORTS, options: { edit: false, internal: false } },
        // { label: 'Validação Audiogest', path: PATHS.PASSMUSICA_VALIDATION },
    ],

    [USER_TYPES.GUEST]: [
        { label: 'Login', path: PATHS.LOGIN },
    ]
};


const getUniqueRoutes = (pages) => {
    const routesMap = {};

    Object.values(USER_TYPES).forEach((userType) => {
        if (pages[userType]) {
            pages[userType].forEach((page) => {
                if (!routesMap[page.path]) {
                    routesMap[page.path] = {
                        path: page.path,
                        component: getPageComponentName(page.path),
                        access: [],
                        pageConfig: page,
                    };
                }
                routesMap[page.path].access.push(userType);
            });
        }
    });

    return Object.values(routesMap);
};

const getPageComponentName = (path) => {
    switch (path) {
        case PATHS.HOME:
            return 'HomePage';
        case PATHS.LOGIN:
            return 'LoginPage';
        case PATHS.PASSMUSICA_VALIDATION:
            return 'PassMusicaValidationPage';
        case PATHS.CONTRACT_LIST:
            return 'ContractListPage';
        case PATHS.CLIENTS_REPORTS:
            return 'ClientReportPage';
        case PATHS.FONOGRAMAS_REPORTS:
            return 'FonogramReportPage';
        case PATHS.USERS:
            return 'UsersPage';
        case PATHS.BOXES:
            return 'BoxesPage';
        default:
            return 'NotFoundPage';
    }
};

export const ROUTES = getUniqueRoutes(PAGES);

// Backend URLs from config file (computed dynamically)
// Use getters to ensure values are computed at access time, not import time
export const getBackendURL = () => CONFIG.BACKEND_URL;
export const getBackendBaseURL = () => CONFIG.BACKEND_BASE_URL;

// For backward compatibility, export as computed values
// Note: These will be computed each time they're accessed
export const BACKEND_URL = CONFIG.BACKEND_URL;
export const BACKEND_BASE_URL = CONFIG.BACKEND_BASE_URL;

// Helper function to build endpoint URLs dynamically
const buildEndpoint = (path) => {
    const baseURL = CONFIG.BACKEND_URL;
    return `${baseURL}${path}`;
};

export const ENDPOINTS = {
    get LOGIN() { return buildEndpoint('/auth/login/'); },
    get REFRESH_TOKEN() { return buildEndpoint('/auth/refresh/'); },
    get REEINVITE() { return buildEndpoint('/auth/reinvite/'); },
    get USERS() { return buildEndpoint('/users/'); },
    get PARTNERS() { return buildEndpoint('/partners/'); },
    get PARTNERS_BRANDING() { return buildEndpoint('/partners/branding/'); },
    get STATISTICS() { return buildEndpoint('/statistics/'); },
    get STATISTICS_STATUS() { return buildEndpoint('/statistics/status/'); },
    get NOTIFICATIONS() { return buildEndpoint('/notifications/'); },

    // Phonograms
    get PHONOGRAMS() { return buildEndpoint('/phonogram_reports/'); },
    get PHONOGRAMS_EXPORT() { return buildEndpoint('/phonogram_reports/export/'); },
    get PHONOGRAMS_ADD() { return buildEndpoint('/phonogram_reports/'); },
    get PHONOGRAMS_IMPORT() { return buildEndpoint('/phonogram_reports/import/'); },
    get PHONOGRAMS_SUBMIT() { return buildEndpoint('/phonogram_reports/submit/'); },

    get PHONOGRAMS_FILTER_IMPORTED() { return buildEndpoint('/phonogram_reports/filters/imported/'); },
    get PHONOGRAMS_FILTER_ARTIST() { return buildEndpoint('/phonogram_reports/filters/artist/'); },
    get PHONOGRAMS_FILTER_PARTNER() { return buildEndpoint('/phonogram_reports/filters/partner/'); },
    get PHONOGRAMS_FILTER_CLIENT_NAME() { return buildEndpoint('/phonogram_reports/filters/client_name/'); },
    get PHONOGRAMS_FILTER_LABEL() { return buildEndpoint('/phonogram_reports/filters/label/'); },
    get PHONOGRAMS_FILTER_REFERENCE_DATE() { return buildEndpoint('/phonogram_reports/filters/reference_date/'); },
    get PHONOGRAMS_FILTER_DELETABLE_REFERENCE_DATE() { return buildEndpoint('/phonogram_reports/filters/deletable_reference_dates/'); },

    // Contracts
    get CONTRACTS() { return buildEndpoint('/contracts/'); },
    get CONTRACTS_EXPORT() { return buildEndpoint('/contracts/export/'); },
    get CONTRACTS_ADD() { return buildEndpoint('/contracts/'); },
    get CONTRACTS_IMPORT() { return buildEndpoint('/contracts/import/'); },
    get CONTRACTS_CODE_LOOKUP() { return buildEndpoint('/contracts/code_lookup/'); },

    get CONTRACTS_FILTER_IMPORTED() { return buildEndpoint('/contracts/filters/imported/'); },
    get CONTRACTS_FILTER_ARCHIVED() { return buildEndpoint('/contracts/filters/archived/'); },
    get CONTRACTS_FILTER_DISCTRICT() { return buildEndpoint('/contracts/filters/district/'); },
    get CONTRACTS_FILTER_LOCALITY() { return buildEndpoint('/contracts/filters/locality/'); },
    get CONTRACTS_FILTER_MUNICIPALITY() { return buildEndpoint('/contracts/filters/municipality/'); },
    get CONTRACTS_FILTER_TYPE() { return buildEndpoint('/contracts/filters/type/'); },

    // Reports
    get REPORTS() { return buildEndpoint('/contract_reports/'); },
    get REPORTS_EXPORT() { return buildEndpoint('/contract_reports/export/'); },
    get REPORTS_ADD() { return buildEndpoint('/contract_reports/'); },
    get REPORTS_IMPORT() { return buildEndpoint('/contract_reports/import/'); },
    get REPORTS_SUBMIT() { return buildEndpoint('/contract_reports/submit/'); },

    get REPORTS_FILTER_IMPORTED() { return buildEndpoint('/contract_reports/filters/imported/'); },
    get REPORTS_FILTER_HAS_RIGHTS() { return buildEndpoint('/contract_reports/filters/has_rights/'); },
    get REPORTS_FILTER_PARTNER() { return buildEndpoint('/contract_reports/filters/partner/'); },
    get REPORTS_FILTER_CLIENT_NAME() { return buildEndpoint('/contract_reports/filters/client_name/'); },
    get REPORTS_FILTER_REFERENCE_DATE() { return buildEndpoint('/contract_reports/filters/reference_date/'); },
    get REPORTS_FILTER_DELETABLE_REFERENCE_DATE() { return buildEndpoint('/contract_reports/filters/deletable_reference_dates/'); },

    // Boxes
    get BOXES() { return buildEndpoint('/boxes/'); },
    get BOXES_EXPORT() { return buildEndpoint('/boxes/export/'); },
    get BOXES_ADD() { return buildEndpoint('/boxes/'); },
    get BOXES_IMPORT() { return buildEndpoint('/boxes/import/'); },

    get BOXES_FILTER_IMPORTED() { return buildEndpoint('/boxes/filters/imported/'); },
    get BOXES_FILTER_ARCHIVED() { return buildEndpoint('/boxes/filters/archived/'); },
    get BOXES_FILTER_SECTOR() { return buildEndpoint('/boxes/filters/sector/'); },
    get BOXES_FILTER_TYPE() { return buildEndpoint('/boxes/filters/type/'); },
    get BOXES_FILTER_CONTRACT_TYPE() { return buildEndpoint('/boxes/filters/contract_type/'); },
    get BOXES_FILTER_PARTNER() { return buildEndpoint('/boxes/filters/partner/'); },

    get CONTRACTS_FILTER_SECTOR() { return buildEndpoint('/contracts/filters/sector/'); },
    get CONTRACTS_FILTER_BOX_TYPE() { return buildEndpoint('/contracts/filters/box_type/'); },
    get CONTRACTS_FILTER_PARTNER() { return buildEndpoint('/contracts/filters/partner/'); },

    get REPORTS_FILTER_CONTRACT_TYPE() { return buildEndpoint('/contract_reports/filters/contract_type/'); },
    get REPORTS_FILTER_SECTOR() { return buildEndpoint('/contract_reports/filters/sector/'); },
    get REPORTS_FILTER_BOX_TYPE() { return buildEndpoint('/contract_reports/filters/box_type/'); },

    get PHONOGRAMS_FILTER_CONTRACT_TYPE() { return buildEndpoint('/phonogram_reports/filters/contract_type/'); },
    get PHONOGRAMS_FILTER_SECTOR() { return buildEndpoint('/phonogram_reports/filters/sector/'); },
    get PHONOGRAMS_FILTER_BOX_TYPE() { return buildEndpoint('/phonogram_reports/filters/box_type/'); },
};